import axios from 'axios';
import { currentlySelectedLanguage } from '../helper';

const billPayClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_BILL_PAY,
    // baseURL: "https://customer-bill-pay-api.windsinc.in",
    withCredentials: true
});
//Request Interceptor
billPayClient.interceptors.request.use(
    function(config) {
      config.headers['Accept-Language'] =  currentlySelectedLanguage();
      // config.headers["Authorization"] = `Bearer ${process.env.REACT_APP_TOKEN}`;
      // Do something before request is sent
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  export default billPayClient;